var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 21.1173C0 31.5578 7.58275 40.2395 17.5 42V26.8328H12.25V21H17.5V16.3328C17.5 11.0828 20.8827 8.16725 25.6672 8.16725C27.1827 8.16725 28.8173 8.4 30.3328 8.63275V14H27.65C25.0828 14 24.5 15.2827 24.5 16.9172V21H30.1L29.1672 26.8328H24.5V42C34.4172 40.2395 42 31.5595 42 21.1173C42 9.5025 32.55 0 21 0C9.45 0 0 9.5025 0 21.1173Z","fill":"black"}));
}

Facebook.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
